module.exports = __webpack_public_path__ + "static/img/complate.ab30301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/complate.png
// module id = QdwA
// module chunks = 0